/* Vyrox21 — Trasforma announcement bar Horizon in marquee scorrevole */
(function() {
  'use strict';

  function makeMarquee(barEl) {
    if (barEl.dataset.v21Marquee === '1') return;
    var inner = barEl.querySelector('.announcement-bar__text, .announcement, [class*="announcement"]:not(.announcement-bar)') || barEl;
    var content = (inner.textContent || '').trim();
    if (!content) return;

    // Wrap in marquee container
    inner.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'v21-marquee';
    var track = document.createElement('div');
    track.className = 'v21-marquee-track';
    // Duplicate text 5 times for seamless loop
    for (var i = 0; i < 5; i++) {
      var span = document.createElement('span');
      span.className = 'v21-marquee-item';
      span.innerHTML = content + '&nbsp;&nbsp;&middot;&nbsp;&nbsp;';
      track.appendChild(span);
    }
    wrap.appendChild(track);
    inner.appendChild(wrap);
    barEl.dataset.v21Marquee = '1';
  }

  function scan() {
    var bars = document.querySelectorAll('.announcement-bar, header-announcements, .header-announcement-bar, [class*="announcement-bar"]');
    bars.forEach(makeMarquee);
  }

  function injectStyles() {
    if (document.getElementById('v21-marquee-style')) return;
    var s = document.createElement('style');
    s.id = 'v21-marquee-style';
    s.textContent = [
      '.announcement-bar, .header-announcement-bar, header-announcements, [class*="announcement-bar"] { background: #1f3aaa !important; color: #fff !important; padding-block-start: 3px !important; padding-block-end: 3px !important; min-height: 0 !important; }',
      '.announcement-bar *, .header-announcement-bar *, header-announcements * { color: #fff !important; font-size: 10.5px !important; line-height: 1.3 !important; letter-spacing: 0.2px !important; }',
      '.v21-marquee { display: flex; overflow: hidden; width: 100%; mask-image: linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%); -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%); }',
      '.v21-marquee-track { display: flex; flex-shrink: 0; animation: v21-marquee-scroll 220s linear infinite; will-change: transform; }',
      '.v21-marquee-track:hover { animation-play-state: paused; }',
      '.v21-marquee-item { flex-shrink: 0; padding: 0 8px; white-space: nowrap; color: #fff; font-size: 10.5px !important; }',
      '@media (max-width: 600px) {',
      '  .announcement-bar, .header-announcement-bar, header-announcements, [class*="announcement-bar"] { padding-block-start: 2px !important; padding-block-end: 2px !important; }',
      '  .announcement-bar *, .header-announcement-bar *, header-announcements *, .v21-marquee-item { font-size: 9.5px !important; line-height: 1.2 !important; }',
      '  .v21-marquee-item { padding: 0 6px !important; }',
      '}',
      '@keyframes v21-marquee-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }',
    ].join('\n');
    document.head.appendChild(s);
  }

  function init() {
    injectStyles();
    scan();
    var mo = new MutationObserver(function(){ scan(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
